import type { ChannelPartner } from "@/types/realEstate";
import { ChannelPartnerList } from "./ChannelPartnerList";

export default {
  list: ChannelPartnerList,
  recordRepresentation: (record: ChannelPartner) =>
    `${record?.agency_name} (${record?.contact_person})`,
};
